import installHotjar from './installHotjar';
import { EXPERIENCE_DOMAIN_CONFIG, EXPERIENCE_HOSTNAMES, SessionStore } from '../constants';
import { getCompanyId } from '../common/utils/gaEvents';
import { getCurrentLocale } from '../common/utils/cookies';
import { getProjectId } from '../common/utils/sessionStorage';
import { useEffect } from 'react';
import { useAppSelector } from '../store/hook';

export default function useHotjar(enabled: boolean, triggerCode: string, isUseEndWorkflowCompleted?: boolean): void {
  const template = useAppSelector((state) => state.template);
  const candidate = useAppSelector((state) => state.candidate);

  isUseEndWorkflowCompleted = isUseEndWorkflowCompleted ?? true;

  useEffect(() => {
    if (enabled && triggerCode && isUseEndWorkflowCompleted) {
      const triggerCodes = sessionStorage.getItem(SessionStore.surveyTriggerCodes);
      const completedSurveyTriggerCodes: string[] | undefined = triggerCodes && JSON.parse(triggerCodes);

      if (
        !completedSurveyTriggerCodes ||
        (completedSurveyTriggerCodes && completedSurveyTriggerCodes.length === 0) ||
        (completedSurveyTriggerCodes && !completedSurveyTriggerCodes.includes(triggerCode))
      ) {
        installHotjar().then(() => {
          const CandidateId = candidate?.candidateId.toString();
          const TemplateId = template?.id;
          const CompanyId = getCompanyId(template);
          const LanguageCode = getCurrentLocale().toUpperCase();
          const ProjectID = getProjectId()?.toString() || '0';
          const hostname = window.location.hostname as EXPERIENCE_DOMAIN_CONFIG;

          window?.hj('identify', CandidateId, {
            CandidateId,
            TemplateId,
            CompanyId,
            ProjectID,
            LanguageCode,
            TriggerCode: triggerCode,
            Environment: EXPERIENCE_HOSTNAMES[hostname],
          });

          window?.hj('trigger', triggerCode);
        });
      }
    }

    return (): void => {
      const hotjarWidget = document.getElementsByClassName('_hj-widget-container')[0] as HTMLDivElement;

      if (hotjarWidget) {
        hotjarWidget.remove();
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled, triggerCode, isUseEndWorkflowCompleted]);
}
